import "./OurMission.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const AboutUsSection = () => {
  const labelRef = useRef(null);
  const titleRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Vertical label fades in
      gsap.from(labelRef.current, {
        scrollTrigger: {
          trigger: labelRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        y: 30,
        duration: 1,
        ease: "power3.out",
      });

      // Title fades up
      gsap.from(titleRef.current, {
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        y: 40,
        duration: 1.1,
        delay: 0.15,
        ease: "power3.out",
      });

      // Button fades up last
      gsap.from(buttonRef.current, {
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        y: 20,
        duration: 0.9,
        delay: 0.5,
        ease: "power3.out",
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section className="mission-section">
      <div className="mission-container">
        <div className="mission-label-wrap" ref={labelRef}>
          <span className="mission-label">About Us</span>
        </div>

        <div className="mission-text">
          <h2 className="mission-title" ref={titleRef}>
            <span className="mission-brand">LRM Management Inc.</span> helps artists grow by providing hands&#8209;on support in entertainment, comedy, and digital media, from tours and production to branding and social media. We empower clients with tools to succeed and protect their careers and legacies.
          </h2>

          <Link to="/about" className="mission-button" ref={buttonRef}>
            <span className="mission-button-label">Our Story</span>
            <span className="mission-button-arrow" aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
